module.exports = __webpack_public_path__ + "static/img/4.b99e8ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/eng/4.png
// module id = l+sp
// module chunks = 0